/**
 * /api/users — CRUD + preferences.
 */

import { http } from './httpClient';

export async function listUsers(opts = {}) {
  const result = await http.get('/users', opts);
  return result.data;
}

export async function getUser(id, opts = {}) {
  const result = await http.get(`/users/${encodeURIComponent(id)}`, opts);
  return result.data;
}

export async function getUserByEmail(email, opts = {}) {
  const result = await http.get(`/users/by-email/${encodeURIComponent(email)}`, opts);
  return result.data;
}

export async function createUser(data, opts = {}) {
  const result = await http.post('/users', data, opts);
  return result.data;
}

export async function updateUser(id, patch, opts = {}) {
  const result = await http.patch(`/users/${encodeURIComponent(id)}`, patch, opts);
  return result.data;
}

export async function deleteUser(id, opts = {}) {
  await http.delete(`/users/${encodeURIComponent(id)}`, opts);
}

// --- Preferences ---

export async function getPreferences(userId, opts = {}) {
  const result = await http.get(`/users/${encodeURIComponent(userId)}/preferences`, opts);
  return result.data || {};
}

export async function setPreferences(userId, patch, opts = {}) {
  const result = await http.patch(`/users/${encodeURIComponent(userId)}/preferences`, patch, opts);
  return result.data || {};
}

export async function removePreference(userId, key, opts = {}) {
  await http.delete(`/users/${encodeURIComponent(userId)}/preferences/${encodeURIComponent(key)}`, opts);
}
